// Dependencies
import { createStitches } from "@stitches/react";

export const { keyframes, styled } = createStitches();
